/** 流量来源的枚举 */
export enum Referrer {
  /** 投放流量 */
  Delivery = 'delivery',
  /** 自然流量 */
  Natural = 'natural',
}
